/**
 * AppLovin Axon 商品分类映射。
 * Axon 要求 item_category_id 发送其官方 taxonomy 的整数 ID（见 Events and Objects 文档的 Category IDs），
 * 站内 products_category_id 不能直接使用。站内在售类目对应关系：
 * - 太阳镜：Apparel & Accessories > Sunglasses = 178
 * - 光学镜/镜框：Vision Care > Eyeglasses = 524（历史上报即硬编码此值）
 * 订单接口暂未返回 is_sunglasses（仅商品详情有），缺省回退 524 保持既有上报口径；
 * 后端补充该字段后购买事件自动区分。
 */
export const AXON_CATEGORY_ID = {
  EYEGLASSES: 524,
  SUNGLASSES: 178,
} as const;

export function toAxonCategoryId(flags?: {
  is_sunglasses?: number | null;
  is_glass?: number | null;
}): number {
  return flags?.is_sunglasses === 1 ? AXON_CATEGORY_ID.SUNGLASSES : AXON_CATEGORY_ID.EYEGLASSES;
}
